// Login.js - Professional Login with Wipro + Trane Branding
import React, { useState } from "react";
import "./Login-New.css";
import wiproLogo from "./assets/wipro1.png";
import traneLogo from './assets/trane-logo.svg';
import { FaEnvelope, FaLock } from "react-icons/fa";
import { useMsal } from '@azure/msal-react';
import { loginRequest } from './authConfig';

const Login = ({ onLogin, authenticationError = '' }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const { instance } = useMsal();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");
    
    try {
      const errorMessage = await onLogin(email, password);
      if (errorMessage) {
        setError(errorMessage === 'Origin is not allowed' ? 'Continue with SSO.' : errorMessage);
      }
    } catch (error) {
      setError(error.message || 'Email/password sign-in failed.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSSOLogin = async () => {
    console.log('SSO Login button clicked');
    console.log('Login Request:', loginRequest);
    
    try {
      setIsLoading(true);
      setError("");
      
      if (!instance) {
        throw new Error('MSAL instance not initialized');
      }
      
      console.log('Starting SSO redirect...');
      // Use redirect instead of popup for better compatibility
      await instance.loginRedirect(loginRequest);
      console.log('Redirect initiated');
    } catch (error) {
      console.error('SSO Login failed:', error);
      console.error('Error details:', error.errorCode, error.errorMessage);
      setError(`SSO login failed: ${error.errorMessage || error.message || 'Please try again.'}`);
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      {/* Top Bar */}
      <div className="login-top-bar">
        <div className="top-bar-content">
          <img src={traneLogo} alt="Trane Technologies" className="top-bar-trane-logo" />
          <h1 className="top-bar-title">AGENT ASSIST</h1>
          <span className="powered-by">Powered by</span>
          <img src={wiproLogo} alt="Wipro" className="top-bar-wipro-logo" />
        </div>
      </div>

      {/* Main Content */}
      <div className="login-content-area">
        <div className="login-container">
          <div className="login-card">
            {/* Card Header */}
            <div className="login-header">
              <h2 className="login-title">AGENT ASSIST</h2>
              <p className="login-subtitle">Welcome Back</p>
            </div>

            {/* SSO Login Button */}
            <button 
              type="button"
              className="sso-login-button-primary"
              onClick={handleSSOLogin}
              disabled={isLoading}
            >
              {isLoading ? 'SIGNING IN...' : 'CONTINUE WITH SSO LOGIN'}
            </button>

            {/* Divider */}
            <div className="login-divider">
              <span>Or continue with email</span>
            </div>

            {/* Login Form */}
            <form className="login-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <div className="input-with-icon">
                  <FaEnvelope className="input-icon" />
                  <input
                    className="form-input"
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>
              </div>

              <div className="form-group">
                <div className="input-with-icon">
                  <FaLock className="input-icon" />
                  <input
                    className="form-input"
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>
              </div>

              <div className="forgot-password-link">
                <a href="#forgot">Forgot password?</a>
              </div>

              {(error || authenticationError) && (
                <div className="error-message" role="alert">{error || authenticationError}</div>
              )}

              <button 
                type="submit" 
                className="login-button"
                disabled={isLoading}
              >
                {isLoading ? 'SIGNING IN...' : 'SIGN IN'}
              </button>
              
              {/* Request Access Button */}
              <button 
                type="button" 
                className="request-access-button"
                onClick={() => window.open('https://tranetechnologies.service-now.com/now/nav/ui/classic/params/target/com.glideapp.servicecatalog_cat_item_view.do%3Fv%3D1%26sysparm_id%3D1e73a9491b930194d3a7a9b3b24bcb23', '_blank')}
              >
                REQUEST ACCESS
              </button>
            </form>

            {/* Footer Links */}
            <div className="login-footer">
              <a href="#contact">Contact us</a>
              <span className="footer-separator">|</span>
              <a href="#privacy">Privacy</a>
              <span className="footer-separator">|</span>
              <a href="#terms">Terms of use</a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="login-bottom-bar">
        <div className="bottom-bar-content">
          <img src={wiproLogo} alt="Wipro" className="bottom-bar-wipro-logo" />
          <p className="bottom-bar-copyright">Copyright © 2026 Wipro LTD. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
